module.exports = __webpack_public_path__ + "img/logo-argecam.14e02cf7.png";